import { Trans } from '@lingui/react/macro';
import { Popover, PopoverButton, PopoverPanel } from '@headlessui/react';
import Icon from 'components/Icon';
import CustomerAllowanceToggle from './CustomerAllowanceToggle';
import CarConfiguratorMenuItem from './CarConfiguratorMenuItem';
import Download3dSnapshotMenuItem from './Download3dSnapshotMenuItem';
import Download2dImageMenuItem from './Download2dImageMenuItem';
import DownloadComparisonImageMenuItem from './DownloadComparisonImageMenuItem';
import DownloadTransparent2dImageMenuItem from './DownloadTransparent2dImageMenuItem';

export default function DealerToolsMenu({
  svgClassname,
  popoverColor,
}: {
  svgClassname?: string;
  popoverColor?: string;
}) {
  return (
    <Popover className="relative" part="dealer-tools">
      <PopoverButton
        data-testid="dealer-tools-button"
        className="inline-flex items-center gap-x-1 text-sm/6 font-semibold"
      >
        <span className="ex3d-button-text">
          <Trans>Dealer Tools</Trans>
        </span>
        <Icon aria-hidden="true" className={`${svgClassname} ex3d-icon--chevron size-5`} />
      </PopoverButton>

      <PopoverPanel
        transition
        className="absolute left-1/2 z-[101] mt-1 flex w-screen max-w-min -translate-x-1/2 px-4 transition data-[closed]:translate-y-1 data-[closed]:opacity-0 data-[enter]:duration-200 data-[leave]:duration-150 data-[enter]:ease-out data-[leave]:ease-in"
      >
        <div
          className="w-auto min-w-72 shrink rounded-md p-4 text-sm/6 font-semibold text-white shadow-lg empty:hidden"
          style={{ backgroundColor: popoverColor }}
        >
          <CarConfiguratorMenuItem itemType="dcc" />
          <CarConfiguratorMenuItem itemType="scc" />
          <CustomerAllowanceToggle />
          <Download3dSnapshotMenuItem />
          <Download2dImageMenuItem />
          <DownloadTransparent2dImageMenuItem />
          <DownloadComparisonImageMenuItem />

          {/* Other menu items can look like this: */}
          {/* <a key={item.name} href={item.href} className="flex p-2 hover:text-neon-100">
              <span className="grow">{item.name}</span>
              <Icon aria-hidden="true" className="ex3d-icon--chevron size-5" />
            </a> */}
        </div>
      </PopoverPanel>
    </Popover>
  );
}
